import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import * as tribunalAPI from '@debbie/cortex/dist/api/tribunal.js';
import helpers from '@debbie/common/dist/economy/helpers/index.js';
import { CourtMeetingState, meetingTypes, } from '@debbie/common/dist/tribunal/jobs/types.js';
import { Button, DateInput, Input, Modal, Money, MoneyInput, Select, Table, Well, } from '../../../index.js';
import q from '@debbie/cortex/dist/query.js';
import { tribunalCasesEntity, tribunalJobsEntity, } from '@debbie/cortex/dist/tribunal/index.js';
import { courts } from '@debbie/common/dist/court/index.js';
import WYSIWYGEditor from '../../../WYSIWYGEditor.js';
import { Edit, Printer } from '../../../Icons/index.js';
import { getContactPerson } from '@debbie/common/dist/customers/index.js';
import { useCaseVouchersByCase } from '@debbie/cortex/dist/case-vouchers/index.js';
import { useDocumentsByReference } from '@debbie/cortex/dist/documents/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import THEME from '../../../../theme.js';
import { usePaymentPlansByCaseId } from '@debbie/cortex/dist/paymentPlans/index.js';
import { Interval, PaymentPlanEntryStatus, PaymentPlanEntryTypes, } from '@debbie/common/dist/economy/payment-plans/index.js';
import { getFoundations, } from '@debbie/common/dist/documents/index.js';
import { selectTenantId } from '@debbie/cortex/dist/selectedOwners/selectors.js';
import { addressToString } from '@debbie/common/dist/index.js';
import CaseVouchers from '../../../economy/case-vouchers/CaseVouchers.js';
import { getRKIRegistrations } from '@debbie/common/dist/customers/helpers.js';
import UserRkiRegistrations from '../../../Customers/UserEntites/UserRkiRegistrations.js';
import { notification } from '@debbie/cortex/dist/notifications.js';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors.js';
import { useCase } from '@debbie/cortex/dist/cases/index.js';
import { useCustomer } from '@debbie/cortex/dist/customers/index.js';
import { useCreditor } from '@debbie/cortex/dist/creditors/index.js';
import UserSearch from '../../../search/UserSearch.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import keys from '@debbie/common/dist/cache/keys.js';
import { bespokeTenants } from '@debbie/common/dist/bespoke/index.js';
import { isCaseworker } from '@debbie/common/dist/permissions/index.js';
import { objectBy } from '@debbie/common/dist/util/index.js';
import { usePropertyTypes } from '@debbie/cortex/dist/properties/index.js';
import { getMentionSuggestions } from '@debbie/common/dist/templates/suggestions.js';
import { TemplateType } from '@debbie/common/dist/templates/index.js';
const CourtMeetingJob = (props) => {
    const { job } = props;
    const lang = useSelector((s) => s.lang);
    const tenantId = useSelector(selectTenantId);
    const [courtMeetingGuideOpen, setCourtMeetingGuideOpen] = useState(false);
    const [changeMeetingDateOpen, setChangeMeetingDateOpen] = useState(false);
    const [assignee, setAssignee] = useState(job.data.assignee ?? null);
    const [changeMeetingLocation, setChangeMeetingLocation] = useState(false);
    const [meetingLocation, setMeetingLocation] = useState(job.data.meetingLocation);
    const court = courts.find((c) => c.courtId === job.data.courtId);
    const meetingType = job.data.meetingTypeId != null
        ? meetingTypes.find((mt) => mt.id === job.data.meetingTypeId)
        : null;
    const meetingTypeLookup = objectBy(meetingTypes, (t) => t.id);
    const assigneePatcher = useMutation((id) => {
        return tribunalAPI.patchJob(job.id, {
            data: {
                ...job.data,
                assignee: id ?? undefined,
            },
        });
    }, {
        onSuccess: () => {
            q.invalidate(keys.write.modify(tribunalJobsEntity, job.id));
            notification({
                title: 'Gemt',
            });
        },
        onError: () => {
            notification({
                title: 'Fejl',
                subtitle: `Opdatering af ${lang.tribunal.assignee} fejlede`,
                theme: 'error',
            });
        },
    });
    const statePatcher = useMutation((state) => {
        return tribunalAPI.patchJob(job.id, {
            data: {
                ...job.data,
                state: state,
            },
        });
    }, {
        onSuccess: () => {
            q.invalidate(keys.write.modify(tribunalJobsEntity, job.id));
            notification({
                title: 'Gemt',
            });
        },
        onError: () => {
            notification({
                title: 'Fejl',
                subtitle: `Opdatering af mødestatus fejlede`,
                theme: 'error',
            });
        },
    });
    return (React.createElement("div", null,
        courtMeetingGuideOpen && (React.createElement(Modal, { onToggle: () => setCourtMeetingGuideOpen(false), header: "Fogedm\u00F8deformular" },
            React.createElement(CourtMeetingForm, { job: job, tribunalCase: props.tribunalCase, closeForm: () => {
                    setCourtMeetingGuideOpen(false);
                }, viewer: "giver" }))),
        React.createElement(Table, { zebra: true },
            meetingType != null ? (React.createElement("tr", null,
                React.createElement("td", { style: { width: '30%' } }, lang.tribunal.courtMeetingType),
                React.createElement("td", null, meetingType.label))) : null,
            React.createElement("tr", null,
                React.createElement("td", { style: { width: '30%' } }, lang.tribunal.meetingDate),
                React.createElement("td", null,
                    React.createElement("b", null, moment(job.data.meetingDate).format('DD/MM/YYYY HH:mm')),
                    ' ',
                    React.createElement(Edit, { style: { cursor: 'pointer' }, onClick: () => setChangeMeetingDateOpen(true) }),
                    changeMeetingDateOpen && (React.createElement(Modal, { onToggle: () => setChangeMeetingDateOpen(false), header: "M\u00F8dedato", maxWidth: "400px" },
                        React.createElement(MeetingDate, { job: job, tribunalCase: props.tribunalCase, onChange: () => setChangeMeetingDateOpen(false) }))),
                    job.data.previousMeetingDates && (React.createElement("div", null,
                        React.createElement("h4", { style: {
                                marginBottom: 0,
                                fontSize: '0.9em',
                            } }, "Tidligere m\u00F8dedatoer"),
                        job.data.previousMeetingDates.map((previousMeetingDate) => (React.createElement("div", null,
                            moment(previousMeetingDate.meetingDate).format('DD/MM/YYYY HH:mm'),
                            ' ',
                            previousMeetingDate.meetingTypeId &&
                                meetingTypeLookup[previousMeetingDate.meetingTypeId]
                                ? `(${meetingTypeLookup[previousMeetingDate.meetingTypeId]
                                    .label})`
                                : null))),
                        React.createElement("br", null),
                        React.createElement("br", null))))),
            court && (React.createElement("tr", null,
                React.createElement("td", { style: { width: '30%' } }, lang.tribunal.court),
                React.createElement("td", null,
                    React.createElement("b", null, court.name)))),
            React.createElement("tr", null,
                React.createElement("td", { style: { width: '30%' } }, lang.tribunal.meetingLocation),
                React.createElement("td", null,
                    React.createElement("div", { style: { display: 'inline-flex', width: '100%' } },
                        changeMeetingLocation ? (React.createElement(Input, { value: meetingLocation || undefined, placeholder: lang.tribunal.meetingLocation, style: { marginBottom: '0px' }, containerStyle: { width: '100%' }, onChange: (value) => setMeetingLocation(value.target.value), button: {
                                value: 'Gem',
                                onClick: async () => {
                                    try {
                                        await tribunalAPI.patchJob(job.id, {
                                            data: {
                                                ...job.data,
                                                meetingLocation: meetingLocation || null,
                                            },
                                        });
                                        q.invalidate(keys.write.modify(tribunalJobsEntity, job.id));
                                        notification({
                                            title: 'Mødested ændret',
                                        });
                                        setChangeMeetingLocation(false);
                                    }
                                    catch (error) {
                                        alert('Der skete en fejl');
                                        console.error(error);
                                    }
                                },
                            } })) : (React.createElement("b", null, job.data.meetingLocation)),
                        React.createElement(Edit, { style: {
                                cursor: 'pointer',
                                alignSelf: 'center',
                                marginLeft: changeMeetingLocation || meetingLocation ? '10px' : '0px',
                            }, onClick: () => setChangeMeetingLocation(!changeMeetingLocation) })))),
            React.createElement("tr", null,
                React.createElement("td", { style: { width: '30%' } }, lang.tribunal.assignee),
                React.createElement("td", null,
                    React.createElement(UserSearch, { filter: (user) => {
                            return isCaseworker(user.tenant.role);
                        }, selected: assignee ?? null, onSelect: async (id) => {
                            setAssignee(id);
                            await assigneePatcher.mutate(id);
                        } }))),
            [bespokeTenants.mortangProd, bespokeTenants.euroIncassoProd].includes(tenantId) && (React.createElement(React.Fragment, null,
                React.createElement("tr", null,
                    React.createElement("td", null, lang.misc.state),
                    React.createElement("td", null,
                        job.data.state != null ? (React.createElement("p", null, lang.courtMeetingState[job.data.state])) : null,
                        job.data.state != CourtMeetingState.Canceled && (React.createElement(Button, { size: "mini", theme: "secondary", loading: statePatcher.isLoading, onClick: () => {
                                statePatcher.mutate(CourtMeetingState.Canceled);
                            } }, "Marker aflyst")))),
                React.createElement("tr", null,
                    React.createElement("td", null),
                    React.createElement("td", null,
                        React.createElement(Button, { style: { float: 'right' }, onClick: () => setCourtMeetingGuideOpen(!courtMeetingGuideOpen) }, "Fogedm\u00F8deformular"))))))));
};
export default CourtMeetingJob;
const MeetingDate = (props) => {
    const [meetingDate, setMeetingDate] = useState(null);
    const [meetingType, setMeetingType] = useState(props.job.data.meetingTypeId);
    return (React.createElement(React.Fragment, null,
        React.createElement(DateInput, { placeholder: "M\u00F8dedato", value: meetingDate, allowNull: true, showTimeSelect: true, onChange: (date) => setMeetingDate(date) }),
        React.createElement(Select, { value: meetingType, onChange: (e) => {
                setMeetingType(e.currentTarget.value);
            } },
            React.createElement("option", null, "--"),
            meetingTypes.map((meetingType) => {
                return (React.createElement("option", { key: meetingType.id, value: meetingType.id }, meetingType.label));
            })),
        React.createElement(Button, { disabled: !meetingDate, onClick: async () => {
                try {
                    if (!meetingDate)
                        return null;
                    await tribunalAPI.patchJob(props.job.id, {
                        data: {
                            ...props.job.data,
                            meetingDate: meetingDate.toISOString(),
                            meetingTypeId: meetingType,
                        },
                    });
                    notification({
                        title: 'Møde omberammet',
                    });
                    props.onChange();
                }
                catch (error) {
                    alert('Der skete en fejl');
                    console.error(error);
                }
                if (props.job.tribunalCaseId) {
                    q.invalidate([
                        ...keys.write.modify(tribunalJobsEntity, props.job.id),
                        ...keys.write.modify(tribunalCasesEntity, props.job.tribunalCaseId),
                    ]);
                }
            }, block: true }, "Registr\u00E9r ny dato")));
};
const WYSIWYG = (props) => {
    const lang = useSelector((s) => s.lang);
    const tenant = useSelector(selectTenant);
    const propertyTypesLoadable = usePropertyTypes();
    const propertyTypes = h.hasData(propertyTypesLoadable)
        ? propertyTypesLoadable.data
        : undefined;
    const [open, setOpen] = useState(false);
    const onToggle = (html) => {
        setOpen(false);
        if (html) {
            props.onSave(html);
        }
    };
    const mentionSuggestions = getMentionSuggestions(lang, TemplateType.LETTER, propertyTypes, tenant);
    return (React.createElement(Well, null,
        React.createElement(Edit, { style: { float: 'right', cursor: 'pointer' }, onClick: () => setOpen(true) }),
        React.createElement("h3", { style: { marginTop: 0, marginRight: '5px', display: 'inline-flex' } }, props.label),
        open && (React.createElement(Modal, { onToggle: () => onToggle(), header: props.label },
            React.createElement(WYSIWYGEditor, { html: props.html || '', onChange: (html) => onToggle(html), mentionSuggestions: mentionSuggestions }))),
        React.createElement("div", { style: {
                cursor: props.editable ? 'pointer' : 'default',
                minHeight: '60px',
                marginTop: '0',
            }, onClick: () => props.editable && setOpen(true), dangerouslySetInnerHTML: { __html: props.html || '' } })));
};
const FormInput = (props) => (React.createElement("div", { style: { marginBottom: '5px', ...props.style } },
    React.createElement("label", { style: { marginRight: '5px', display: 'inline-flex' } },
        props.label,
        ":"),
    props.editable ? (props.type === 'textarea' ? (React.createElement("textarea", { style: { display: 'inline-flex', width: '100%', height: '80px' }, value: props.value, onChange: (e) => props.onChange(e.target.value) })) : (React.createElement("input", { type: props.type || 'text', style: { display: 'inline-flex' }, value: props.value, onChange: (e) => props.onChange(e.target.value) }))) : (React.createElement("p", { style: { margin: '0px', display: 'inline-flex' } }, props.value))));
const FormDisplay = (props) => (React.createElement("div", { style: { marginBottom: '5px', ...props.style } },
    React.createElement("label", { style: { marginRight: '5px', display: 'inline-flex' } },
        props.label,
        ":"),
    React.createElement("p", { style: { margin: '0px', display: 'inline-flex' } }, props.value)));
let tid;
const FormCheckbox = (props) => (React.createElement("div", { style: { marginBottom: '5px' } },
    React.createElement("input", { type: "checkbox", onChange: (e) => props.onToggle(e.target.checked), checked: props.checked }),
    props.label && props.onChange ? (React.createElement(FormInput, { style: { display: 'inline-flex' }, label: props.label, value: props.value, onChange: props.onChange, editable: props.editable, type: props.type })) : (React.createElement("label", { style: { marginRight: '5px', display: 'inline-flex' } }, props.label))));
export const CourtMeetingForm = (props) => {
    const { job } = props;
    const lang = useSelector((s) => s.lang);
    const caseLoader = useCase(props.tribunalCase.caseId);
    const singleCase = h.hasData(caseLoader) ? caseLoader.data : null;
    const customerLoader = useCustomer(singleCase?.customerId);
    const customer = h.hasData(customerLoader) ? customerLoader.data : null;
    const creditorLoader = useCreditor(singleCase?.creditorId);
    const creditor = h.hasData(creditorLoader) ? creditorLoader.data : null;
    const tenant = useSelector(selectTenant);
    const caseVouchers_ = useCaseVouchersByCase(singleCase?.caseId, {
        getDeleted: false,
    });
    const paymentPlans_ = usePaymentPlansByCaseId(singleCase?.caseId);
    const paymentPlans = h.hasData(paymentPlans_) ? paymentPlans_.data : null;
    const documentsLoadable = useDocumentsByReference(singleCase?.caseId);
    const documents = h.hasData(documentsLoadable) ? documentsLoadable.data : null;
    const foundations = documents && getFoundations(documents);
    const caseVouchers = h.hasData(caseVouchers_) &&
        caseVouchers_.data.map((caseVoucher) => {
            return { ...caseVoucher, children: [] };
        });
    const contact = (customer && getContactPerson(customer)) || null;
    const court = courts.find((c) => c.courtId === job.data.courtId);
    const [editable, setEditable] = useState(true);
    const [jobData, setJobData] = useState(job.data);
    const emailPrintFrameRef = useRef(null);
    const print = async () => {
        try {
            // First remove any existing iframe to avoid memory leaks
            if (emailPrintFrameRef.current && emailPrintFrameRef.current.parentNode) {
                document.body.removeChild(emailPrintFrameRef.current);
            }
            // Create a new iframe
            const iframe = document.createElement('iframe');
            iframe.style.position = 'absolute';
            iframe.style.top = '-9999px';
            iframe.style.left = '-9999px';
            iframe.style.width = '1000px'; // Give it an initial width for proper layout
            iframe.style.height = '1000px'; // Give it an initial height for proper layout
            iframe.style.border = 'none';
            // Set sandbox attributes but ensure printing is allowed
            iframe.setAttribute('sandbox', 'allow-same-origin allow-scripts allow-modals allow-popups');
            // Append iframe to document first so it's part of the DOM
            document.body.appendChild(iframe);
            emailPrintFrameRef.current = iframe;
            // Get form content
            const form = document.getElementById('tribunal-court-meeting-form');
            const formContent = form ? form.innerHTML : '';
            // Access the iframe's document safely
            const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
            if (!iframeDoc) {
                throw new Error('Cannot access iframe document');
            }
            // Write content to the iframe's document
            iframeDoc.open();
            iframeDoc.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <meta charset="utf-8">
            <title>Print Document</title>
            <style>
              @page {
                size: A4 portrait;
                margin: 72px 40px;
              }

              html, body {
                margin: 0;
                padding: 0;
                font-size: 0.85em;
                font-family: Arial, sans-serif;
              }

              * {
                print-color-adjust: exact;
                -webkit-print-color-adjust: exact;
                box-sizing: border-box;
              }

              .print-container {
                width: 100%;
                padding: 0;
              }

              img {
                max-height: 200px;
              }

              table, tr, td {
                page-break-inside: avoid;
              }

              div {
                page-break-inside: avoid;
              }

              .page-break {
                page-break-after: always;
                display: block;
                height: 0;
                clear: both;
              }

              /* Add any additional styles from the application */
              ${Array.from(document.styleSheets)
                .filter((sheet) => {
                try {
                    // Filter out cross-origin stylesheets
                    return sheet.cssRules;
                }
                catch (e) {
                    return false;
                }
            })
                .map((sheet) => {
                try {
                    return Array.from(sheet.cssRules)
                        .map((rule) => rule.cssText)
                        .join('\n');
                }
                catch (e) {
                    return '';
                }
            })
                .join('\n')}
            </style>
          </head>
          <body>
            <div class="print-container">${formContent}</div>
          </body>
        </html>
      `);
            iframeDoc.close();
            // Wait for iframe content to load
            await new Promise((resolve) => {
                if (iframe.contentWindow?.document.readyState === 'complete') {
                    resolve();
                }
                else {
                    iframe.onload = () => resolve();
                    // Fallback timeout
                    setTimeout(resolve, 1000);
                }
            });
            // Execute print
            if (iframe.contentWindow) {
                try {
                    iframe.contentWindow.focus();
                    iframe.contentWindow.print();
                    // Wait for printing to complete (inexact but better than nothing)
                    await new Promise((resolve) => setTimeout(resolve, 1000));
                }
                catch (printError) {
                    console.error('Print error:', printError);
                }
            }
            // Clean up after a delay to ensure print dialog has time to appear
            setTimeout(() => {
                if (emailPrintFrameRef.current &&
                    emailPrintFrameRef.current.parentNode) {
                    try {
                        document.body.removeChild(emailPrintFrameRef.current);
                        emailPrintFrameRef.current = null;
                    }
                    catch (e) {
                        console.error('Error removing iframe:', e);
                    }
                }
            }, 100);
        }
        catch (error) {
            console.error('Print setup error:', error);
            // Clean up on error
            if (emailPrintFrameRef.current && emailPrintFrameRef.current.parentNode) {
                try {
                    document.body.removeChild(emailPrintFrameRef.current);
                    emailPrintFrameRef.current = null;
                }
                catch (e) {
                    console.error('Error removing iframe during cleanup:', e);
                }
            }
        }
    };
    const meetingNotesSubmitter = useMutation((id, data) => {
        return tribunalAPI.patchJob(id, { data: data });
    }, {
        onSuccess: (res, id) => {
            q.invalidate(keys.write.modify(tribunalJobsEntity, id));
            notification({ title: 'Gemt' });
            if (props.closeForm) {
                props.closeForm();
            }
        },
        onError: () => {
            notification({
                title: 'Ikke gemt',
                subtitle: 'Færdig markeringen er ikke gemt',
                theme: 'error',
            });
        },
    });
    const save = async (data, options = {}) => {
        const newData = { ...jobData, ...data };
        setJobData(newData);
        const fn = async () => {
            try {
                await tribunalAPI.patchJob(props.job.id, {
                    data: newData,
                });
                q.invalidate(keys.write.modify(tribunalJobsEntity, props.job.id));
                notification({
                    title: 'Formular gemt',
                });
            }
            catch (error) {
                alert('Der skete en fejl');
                console.error(error);
            }
            if (job.tribunalCaseId) {
                q.invalidate(keys.write.modify(tribunalCasesEntity, job.tribunalCaseId));
            }
        };
        clearTimeout(tid);
        if (options.submission) {
            fn();
            if (props.closeForm) {
                props.closeForm();
            }
        }
        else {
            tid = setTimeout(fn, 700);
        }
    };
    const rkiRegistrations = contact && getRKIRegistrations(contact.details);
    return (React.createElement("div", null,
        React.createElement(Printer, { style: {
                cursor: 'pointer',
                width: '27px',
                height: '27px',
                float: 'right',
            }, onClick: async () => {
                await setEditable(false); //await is needed and does have an effect
                await print();
                await setEditable(true);
            } }),
        React.createElement("div", { id: "tribunal-court-meeting-form" },
            React.createElement("h1", null,
                "Retsm\u00F8de ",
                props.tribunalCase.reference),
            court && React.createElement(FormDisplay, { label: "Retskreds", value: court.name }),
            job.data.meetingLocation && (React.createElement(FormDisplay, { label: "M\u00F8dested", value: job.data.meetingLocation })),
            React.createElement(FormDisplay, { label: "M\u00F8dedato", value: moment(job.data.meetingDate).format('DD/MM/YYYY HH:mm'), style: { marginBottom: '20px' } }),
            React.createElement("div", { style: { display: 'flex' } },
                React.createElement(Well, { style: {
                        display: 'inline-block',
                        width: '50%',
                        verticalAlign: 'top',
                        marginRight: '10px',
                    } },
                    React.createElement("h3", { style: { marginTop: 0 } }, "Kreditor"),
                    React.createElement("p", null,
                        React.createElement("b", null, creditor?.name),
                        creditor?.address ? (React.createElement(React.Fragment, null,
                            React.createElement("br", null),
                            addressToString(creditor?.address))) : null),
                    React.createElement(FormDisplay, { label: "CVR-nr.", value: creditor?.centralRegisterId }),
                    React.createElement(FormDisplay, { label: "Momsregistreret", value: creditor?.vatRegistered ? 'Ja' : 'Nej' })),
                React.createElement(Well, { style: {
                        display: 'inline-block',
                        width: '50%',
                        verticalAlign: 'top',
                    } },
                    React.createElement("h3", { style: { marginTop: 0 } }, "Debitor"),
                    React.createElement("p", null,
                        React.createElement("b", null, contact?.details.name),
                        contact?.details.address ? (React.createElement(React.Fragment, null,
                            React.createElement("br", null),
                            addressToString(contact.details.address))) : null),
                    contact?.details.isCompany ? (React.createElement(FormDisplay, { label: "CVR-nr.", value: contact?.details.cvr })) : (React.createElement(FormDisplay, { label: "CPR-nr.", value: contact?.details.cpr })),
                    React.createElement(FormDisplay, { label: "E-mail", value: contact?.details.email }),
                    React.createElement(FormDisplay, { label: "Telefon", value: contact?.details.phone
                            ? `+${contact?.details.phone?.locale} ${contact?.details.phone?.number}`
                            : null }))),
            React.createElement("br", null),
            React.createElement("hr", null),
            React.createElement("br", null),
            React.createElement(WYSIWYG, { label: "Bem\u00E6rkninger", html: job.data.meetingForm?.remark, editable: editable, onSave: async (value) => {
                    await save({
                        meetingForm: {
                            ...job.data.meetingForm,
                            remark: value,
                        },
                    });
                } }),
            React.createElement("br", null),
            React.createElement("hr", null),
            React.createElement("h3", null, "Sagens \u00F8konomi"),
            singleCase && caseVouchers && (React.createElement(CaseVouchers, { caseVouchers: caseVouchers, singleCase: singleCase })),
            React.createElement("br", null),
            React.createElement("hr", null),
            React.createElement("br", null),
            React.createElement("div", { style: { display: 'flex' } },
                React.createElement(Well, { style: {
                        display: 'inline-block',
                        width: '50%',
                        verticalAlign: 'top',
                        marginRight: '10px',
                    } },
                    React.createElement("h3", null, "Fundamenter"),
                    foundations && foundations.length ? (React.createElement(React.Fragment, null,
                        React.createElement(Table, { overflowX: "hidden" },
                            React.createElement("tbody", null, foundations.map((document) => {
                                return (React.createElement("tr", null,
                                    React.createElement("td", null,
                                        lang.documentTypes[document.type],
                                        " "),
                                    React.createElement("td", null, moment(document.signedAt || document.date).format(THEME.DATE_FORMAT_SHORT))));
                            }))))) : (React.createElement("p", null, "Ingen fundamenter"))),
                React.createElement(Well, { style: {
                        display: 'inline-block',
                        width: '50%',
                        verticalAlign: 'top',
                    } },
                    React.createElement("h3", null, "Tidligere afdragsordninger"),
                    paymentPlans && paymentPlans.length > 0 ? (React.createElement(React.Fragment, null,
                        React.createElement(Table, { overflowX: "hidden" },
                            React.createElement("thead", null,
                                React.createElement("tr", null,
                                    React.createElement("th", { style: { paddingRight: '10px' } }, "Startdato"),
                                    React.createElement("th", { style: { paddingRight: '10px' } }, "Interval"),
                                    React.createElement("th", { style: { paddingRight: '10px' } }, "Antal afdrag"),
                                    React.createElement("th", { style: { paddingRight: '10px' } }, "Bel\u00F8b pr. afdrag"),
                                    React.createElement("th", { style: { paddingRight: '10px' } }, "Samlet betalt"),
                                    React.createElement("th", { style: { paddingRight: '10px' } }, "Status"))),
                            React.createElement("tbody", null, paymentPlans
                                .sort((a, b) => {
                                return (new Date(b.createdAt).getTime() -
                                    new Date(a.createdAt).getTime());
                            })
                                .map((paymentPlan) => {
                                return (React.createElement("tr", null,
                                    React.createElement("td", null, moment(paymentPlan.config?.startDate).format(THEME.DATE_FORMAT_SHORT)),
                                    React.createElement("td", null, paymentPlan.config?.interval),
                                    React.createElement("td", null,
                                        paymentPlan.plan.reduce((acc, plan) => acc + plan.status ===
                                            PaymentPlanEntryStatus.SETTLED
                                            ? 1
                                            : 0, 0),
                                        ' ',
                                        "/ ",
                                        paymentPlan.plan.length),
                                    React.createElement("td", null, paymentPlan.config?.amount ? (React.createElement(Money, { amount: paymentPlan.config.amount })) : paymentPlan.plan.find((plan) => plan.type === PaymentPlanEntryTypes.NORMAL) ? (React.createElement("div", null,
                                        React.createElement("p", { style: {
                                                display: 'inline-flex',
                                                marginRight: '3px',
                                            } }, "~"),
                                        React.createElement(Money, { amount: paymentPlan.plan.find((plan) => plan.type ===
                                                PaymentPlanEntryTypes.NORMAL)?.amount }))) : ('')),
                                    React.createElement("td", null,
                                        React.createElement(Money, { amount: paymentPlan.plan.reduce((acc, plan) => acc + plan.status ===
                                                PaymentPlanEntryStatus.SETTLED
                                                ? plan.amount
                                                : 0, 0) })),
                                    React.createElement("td", null, lang.paymentPlans[paymentPlan.status])));
                            }))))) : (React.createElement("p", null, "Ingen tidligere afdragsordninger")))),
            React.createElement("div", { className: "page-break" }),
            React.createElement("h3", null, "Sp\u00F8rgsm\u00E5l til aktiver"),
            React.createElement("div", { style: { border: '1px solid black', padding: '10px' } },
                React.createElement("h4", null, "Bolig"),
                React.createElement(FormCheckbox, { label: "Fast ejendom", editable: editable, checked: jobData.meetingForm?.questions?.housing?.fastEjendom, onToggle: async (value) => {
                        await save({
                            meetingForm: {
                                ...jobData.meetingForm,
                                questions: {
                                    ...jobData.meetingForm?.questions,
                                    housing: {
                                        ...jobData.meetingForm?.questions?.housing,
                                        fastEjendom: value,
                                    },
                                },
                            },
                        });
                    }, value: jobData.meetingForm?.questions?.housing?.fastEjendomText, onChange: async (value) => {
                        await save({
                            meetingForm: {
                                ...jobData.meetingForm,
                                questions: {
                                    ...jobData.meetingForm?.questions,
                                    housing: {
                                        ...jobData.meetingForm?.questions?.housing,
                                        fastEjendomText: value,
                                    },
                                },
                            },
                        });
                    } }),
                React.createElement("div", { style: { display: 'inline-flex' } },
                    React.createElement(FormCheckbox, { label: "Andelsbolig, v\u00E6rdi", editable: editable, checked: jobData.meetingForm?.questions?.housing?.andelsbolig, onToggle: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        housing: {
                                            ...jobData.meetingForm?.questions?.housing,
                                            andelsbolig: value,
                                        },
                                    },
                                },
                            });
                        }, value: jobData.meetingForm?.questions?.housing?.andelsboligText, onChange: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        housing: {
                                            ...jobData.meetingForm?.questions?.housing,
                                            andelsboligText: value,
                                        },
                                    },
                                },
                            });
                        } }),
                    React.createElement(FormInput, { label: "Administration/navn p\u00E5 andelsforening", value: jobData.meetingForm?.questions?.housing?.andelsboligForening, editable: editable, style: {
                            marginLeft: editable ? '20px' : '80px',
                            marginTop: '3px',
                        }, onChange: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        housing: {
                                            ...jobData.meetingForm?.questions?.housing,
                                            andelsboligForening: value,
                                        },
                                    },
                                },
                            });
                        } })),
                React.createElement("div", null),
                React.createElement("div", { style: { display: 'inline-flex' } },
                    React.createElement(FormCheckbox, { label: "Lejebolig, indskud", editable: editable, checked: jobData.meetingForm?.questions?.housing?.lejebolig, onToggle: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        housing: {
                                            ...jobData.meetingForm?.questions?.housing,
                                            lejebolig: value,
                                        },
                                    },
                                },
                            });
                        }, value: jobData.meetingForm?.questions?.housing?.lejeboligIndskud, onChange: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        housing: {
                                            ...jobData.meetingForm?.questions?.housing,
                                            lejeboligIndskud: value,
                                        },
                                    },
                                },
                            });
                        } }),
                    React.createElement(FormInput, { label: "Udlejer", value: jobData.meetingForm?.questions?.housing?.lejeboligUdlejer, editable: editable, style: {
                            marginLeft: editable ? '20px' : '80px',
                            marginTop: '3px',
                        }, onChange: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        housing: {
                                            ...jobData.meetingForm?.questions?.housing,
                                            lejeboligUdlejer: value,
                                        },
                                    },
                                },
                            });
                        } })),
                React.createElement(FormInput, { label: "Intet indskud, begrundelse", value: jobData.meetingForm?.questions?.housing
                        ?.lejeboligIntetIndskudBegrundelse, editable: editable, onChange: async (value) => {
                        await save({
                            meetingForm: {
                                ...jobData.meetingForm,
                                questions: {
                                    ...jobData.meetingForm?.questions,
                                    housing: {
                                        ...jobData.meetingForm?.questions?.housing,
                                        lejeboligIntetIndskudBegrundelse: value,
                                    },
                                },
                            },
                        });
                    } }),
                React.createElement("h4", null, "K\u00F8ret\u00F8jer m.m."),
                React.createElement("div", { style: { display: 'inline-flex' } },
                    React.createElement(FormCheckbox, { label: "Bil", editable: editable, checked: jobData.meetingForm?.questions?.vehicles?.car, onToggle: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        vehicles: {
                                            ...jobData.meetingForm?.questions?.vehicles,
                                            car: value,
                                        },
                                    },
                                },
                            });
                        } }),
                    React.createElement(FormCheckbox, { label: "Motorcykel", editable: editable, checked: jobData.meetingForm?.questions?.vehicles?.motorcycle, onToggle: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        vehicles: {
                                            ...jobData.meetingForm?.questions?.vehicles,
                                            motorcycle: value,
                                        },
                                    },
                                },
                            });
                        } }),
                    React.createElement(FormCheckbox, { label: "Campingvogn", editable: editable, checked: jobData.meetingForm?.questions?.vehicles?.camper, onToggle: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        vehicles: {
                                            ...jobData.meetingForm?.questions?.vehicles,
                                            camper: value,
                                        },
                                    },
                                },
                            });
                        } }),
                    React.createElement(FormCheckbox, { label: "B\u00E5d", editable: editable, checked: jobData.meetingForm?.questions?.vehicles?.boat, onToggle: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        vehicles: {
                                            ...jobData.meetingForm?.questions?.vehicles,
                                            boat: value,
                                        },
                                    },
                                },
                            });
                        } }),
                    React.createElement(FormCheckbox, { label: "Leasingaftale", editable: editable, checked: jobData.meetingForm?.questions?.vehicles?.leasing, onToggle: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        vehicles: {
                                            ...jobData.meetingForm?.questions?.vehicles,
                                            leasing: value,
                                        },
                                    },
                                },
                            });
                        } })),
                React.createElement("div", null),
                React.createElement("div", { style: { display: 'inline-flex' } },
                    React.createElement(FormInput, { label: "M\u00E6rke", value: jobData.meetingForm?.questions?.vehicles?.brand, editable: editable, style: { marginTop: '3px' }, onChange: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        vehicles: {
                                            ...jobData.meetingForm?.questions?.vehicles,
                                            brand: value,
                                        },
                                    },
                                },
                            });
                        } }),
                    React.createElement(FormInput, { label: "Model", value: jobData.meetingForm?.questions?.vehicles?.model, editable: editable, style: {
                            marginLeft: editable ? '20px' : '80px',
                            marginTop: '3px',
                        }, onChange: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        vehicles: {
                                            ...jobData.meetingForm?.questions?.vehicles,
                                            model: value,
                                        },
                                    },
                                },
                            });
                        } }),
                    React.createElement(FormInput, { label: "\u00C5rgang", value: jobData.meetingForm?.questions?.vehicles?.year, editable: editable, style: {
                            marginLeft: editable ? '20px' : '80px',
                            marginTop: '3px',
                        }, onChange: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        vehicles: {
                                            ...jobData.meetingForm?.questions?.vehicles,
                                            year: value,
                                        },
                                    },
                                },
                            });
                        } })),
                React.createElement("div", null),
                React.createElement("div", { style: { display: 'inline-flex' } },
                    React.createElement(FormInput, { label: "Reg.nr.", value: jobData.meetingForm?.questions?.vehicles?.licensePlate, editable: editable, style: { marginTop: '3px' }, onChange: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        vehicles: {
                                            ...jobData.meetingForm?.questions?.vehicles,
                                            licensePlate: value,
                                        },
                                    },
                                },
                            });
                        } }),
                    React.createElement(FormInput, { label: "Stelnr.", value: jobData.meetingForm?.questions?.vehicles?.vin, editable: editable, style: {
                            marginLeft: editable ? '20px' : '80px',
                            marginTop: '3px',
                        }, onChange: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        vehicles: {
                                            ...jobData.meetingForm?.questions?.vehicles,
                                            vin: value,
                                        },
                                    },
                                },
                            });
                        } })),
                React.createElement("h4", null, "Virksomhed"),
                React.createElement("div", { style: { display: 'inline-flex' } },
                    React.createElement(FormCheckbox, { label: "Varelager", editable: editable, checked: jobData.meetingForm?.questions?.company?.warehouseStock, onToggle: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        business: {
                                            ...jobData.meetingForm?.questions?.company,
                                            warehouseStock: value,
                                        },
                                    },
                                },
                            });
                        } }),
                    React.createElement(FormCheckbox, { label: "Maskiner", editable: editable, checked: jobData.meetingForm?.questions?.company?.machinery, onToggle: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        business: {
                                            ...jobData.meetingForm?.questions?.company,
                                            machinery: value,
                                        },
                                    },
                                },
                            });
                        } }),
                    React.createElement(FormCheckbox, { label: "Inventar", editable: editable, checked: jobData.meetingForm?.questions?.company?.inventory, onToggle: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        business: {
                                            ...jobData.meetingForm?.questions?.company,
                                            inventory: value,
                                        },
                                    },
                                },
                            });
                        } }),
                    React.createElement(FormCheckbox, { label: "Bankkonti", editable: editable, checked: jobData.meetingForm?.questions?.company?.bankAccount, onToggle: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        business: {
                                            ...jobData.meetingForm?.questions?.company,
                                            bankAccount: value,
                                        },
                                    },
                                },
                            });
                        } }),
                    React.createElement(FormCheckbox, { label: "Andet", editable: editable, checked: jobData.meetingForm?.questions?.company?.other, onToggle: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        business: {
                                            ...jobData.meetingForm?.questions?.company,
                                            other: value,
                                        },
                                    },
                                },
                            });
                        }, value: jobData.meetingForm?.questions?.company?.otherText, onChange: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        business: {
                                            ...jobData.meetingForm?.questions?.company,
                                            otherText: value,
                                        },
                                    },
                                },
                            });
                        } })),
                React.createElement("h4", null, "Andre aktiver"),
                React.createElement(FormInput, { label: "Beskrivelse", value: jobData.meetingForm?.questions?.otherAssets, editable: editable, onChange: async (value) => {
                        await save({
                            meetingForm: {
                                ...jobData.meetingForm,
                                questions: {
                                    ...jobData.meetingForm?.questions,
                                    otherAssets: value,
                                },
                            },
                        });
                    } }),
                React.createElement("h4", null, "Overskydende skat"),
                React.createElement("div", { style: { display: 'inline-flex' } },
                    React.createElement(FormCheckbox, { label: "Ja", editable: editable, checked: jobData.meetingForm?.questions?.excessTax?.yes, onToggle: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        excessTax: {
                                            ...jobData.meetingForm?.questions?.excessTax,
                                            yes: value,
                                        },
                                    },
                                },
                            });
                        } }),
                    React.createElement(FormCheckbox, { label: "Nej, begrundelse hvorfor", editable: editable, checked: jobData.meetingForm?.questions?.excessTax?.no, onToggle: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        excessTax: {
                                            ...jobData.meetingForm?.questions?.excessTax,
                                            no: value,
                                        },
                                    },
                                },
                            });
                        }, value: jobData.meetingForm?.questions?.excessTax?.noReason, onChange: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        excessTax: {
                                            ...jobData.meetingForm?.questions?.excessTax,
                                            noReason: value,
                                        },
                                    },
                                },
                            });
                        } }))),
            React.createElement("div", { className: "page-break" }),
            React.createElement("h3", null, "Sp\u00F8rgsm\u00E5l til \u00F8konomi"),
            React.createElement("div", { style: { border: '1px solid black', padding: '10px' } },
                React.createElement("h4", null, "Personlige forhold"),
                React.createElement("div", { style: { display: 'inline-flex' } },
                    React.createElement(FormInput, { label: "CPR nr.", value: jobData.meetingForm?.questions?.personal?.cpr, editable: editable, style: { marginTop: '3px', marginRight: '50px' }, onChange: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        personal: {
                                            ...jobData.meetingForm?.questions?.personal,
                                            cpr: value,
                                        },
                                    },
                                },
                            });
                        } }),
                    React.createElement(FormCheckbox, { label: "Gift", editable: editable, checked: jobData.meetingForm?.questions?.personal?.relationshipStatus
                            ?.married, onToggle: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        personal: {
                                            ...jobData.meetingForm?.questions?.personal,
                                            relationshipStatus: {
                                                ...jobData.meetingForm?.questions?.personal
                                                    ?.relationshipStatus,
                                                married: value,
                                            },
                                        },
                                    },
                                },
                            });
                        } }),
                    React.createElement(FormCheckbox, { label: "Fraskilt", editable: editable, checked: jobData.meetingForm?.questions?.personal?.relationshipStatus
                            ?.divorced, onToggle: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        personal: {
                                            ...jobData.meetingForm?.questions?.personal,
                                            relationshipStatus: {
                                                ...jobData.meetingForm?.questions?.personal
                                                    ?.relationshipStatus,
                                                divorced: value,
                                            },
                                        },
                                    },
                                },
                            });
                        } }),
                    React.createElement(FormCheckbox, { label: "Samlevende", editable: editable, checked: jobData.meetingForm?.questions?.personal?.relationshipStatus
                            ?.cohabiting, onToggle: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        personal: {
                                            ...jobData.meetingForm?.questions?.personal,
                                            relationshipStatus: {
                                                ...jobData.meetingForm?.questions?.personal
                                                    ?.relationshipStatus,
                                                cohabiting: value,
                                            },
                                        },
                                    },
                                },
                            });
                        } }),
                    React.createElement(FormCheckbox, { label: "Enlig", editable: editable, checked: jobData.meetingForm?.questions?.personal?.relationshipStatus
                            ?.single, onToggle: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        personal: {
                                            ...jobData.meetingForm?.questions?.personal,
                                            relationshipStatus: {
                                                ...jobData.meetingForm?.questions?.personal
                                                    ?.relationshipStatus,
                                                single: value,
                                            },
                                        },
                                    },
                                },
                            });
                        } }),
                    React.createElement(FormCheckbox, { label: "B\u00F8rn/b\u00F8rnebidrag under 18 \u00E5r", editable: editable, checked: jobData.meetingForm?.questions?.personal?.relationshipStatus
                            ?.childrenOrChildSupportUnder18, onToggle: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        personal: {
                                            ...jobData.meetingForm?.questions?.personal,
                                            relationshipStatus: {
                                                ...jobData.meetingForm?.questions?.personal
                                                    ?.relationshipStatus,
                                                childrenOrChildSupportUnder18: value,
                                            },
                                        },
                                    },
                                },
                            });
                        } })),
                React.createElement("div", { style: { display: 'inline-flex' } },
                    React.createElement(FormInput, { label: "Telefonnr.", value: jobData.meetingForm?.questions?.personal?.phone, editable: editable, style: { marginTop: '3px' }, onChange: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        personal: {
                                            ...jobData.meetingForm?.questions?.personal,
                                            phone: value,
                                        },
                                    },
                                },
                            });
                        } }),
                    React.createElement(FormInput, { label: "Email", style: { marginLeft: editable ? '20px' : '80px' }, value: jobData.meetingForm?.questions?.personal?.email, editable: editable, onChange: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        personal: {
                                            ...jobData.meetingForm?.questions?.personal,
                                            email: value,
                                        },
                                    },
                                },
                            });
                        } })),
                React.createElement("h4", null, "\u00D8konomisk situation"),
                React.createElement(FormInput, { label: "Besk\u00E6ftigelse", value: jobData.meetingForm?.questions?.financialSituation?.employment, editable: editable, onChange: async (value) => {
                        await save({
                            meetingForm: {
                                ...jobData.meetingForm,
                                questions: {
                                    ...jobData.meetingForm?.questions,
                                    financialSituation: {
                                        ...jobData.meetingForm?.questions?.financialSituation,
                                        employment: value,
                                    },
                                },
                            },
                        });
                    } }),
                React.createElement(FormInput, { label: "Personlig indkomst pr. m\u00E5ned \u2013 netto", value: jobData.meetingForm?.questions?.financialSituation?.income, editable: editable, type: "number", onChange: async (value) => {
                        await save({
                            meetingForm: {
                                ...jobData.meetingForm,
                                questions: {
                                    ...jobData.meetingForm?.questions,
                                    financialSituation: {
                                        ...jobData.meetingForm?.questions?.financialSituation,
                                        income: value,
                                    },
                                },
                            },
                        });
                    } }),
                React.createElement(FormInput, { label: "\u00C6gtef\u00E6lle/samlevers besk\u00E6ftigelse", value: jobData.meetingForm?.questions?.financialSituation
                        ?.cohabitantEmployment, editable: editable, onChange: async (value) => {
                        await save({
                            meetingForm: {
                                ...jobData.meetingForm,
                                questions: {
                                    ...jobData.meetingForm?.questions,
                                    financialSituation: {
                                        ...jobData.meetingForm?.questions?.financialSituation,
                                        cohabitantEmployment: value,
                                    },
                                },
                            },
                        });
                    } }),
                React.createElement(FormInput, { label: "\u00C6gtef\u00E6lle/samlevers indkomst pr. m\u00E5ned \u2013 netto", value: jobData.meetingForm?.questions?.financialSituation
                        ?.cohabitantIncome, editable: editable, type: "number", onChange: async (value) => {
                        await save({
                            meetingForm: {
                                ...jobData.meetingForm,
                                questions: {
                                    ...jobData.meetingForm?.questions,
                                    financialSituation: {
                                        ...jobData.meetingForm?.questions?.financialSituation,
                                        cohabitantIncome: value,
                                    },
                                },
                            },
                        });
                    } }),
                React.createElement(FormInput, { label: "R\u00E5dighedsbel\u00F8b pr. m\u00E5ned", value: jobData.meetingForm?.questions?.financialSituation
                        ?.availableAmount, editable: editable, type: "number", onChange: async (value) => {
                        await save({
                            meetingForm: {
                                ...jobData.meetingForm,
                                questions: {
                                    ...jobData.meetingForm?.questions,
                                    financialSituation: {
                                        ...jobData.meetingForm?.questions?.financialSituation,
                                        availableAmount: value,
                                    },
                                },
                            },
                        });
                    } }),
                React.createElement("h4", null, "Anden g\u00E6ld"),
                React.createElement("div", { style: { display: 'inline-flex' } },
                    React.createElement(FormInput, { label: "Kreditor", value: jobData.meetingForm?.questions?.otherDebt?.creditor, editable: editable, style: { marginTop: '3px' }, onChange: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        otherDebt: {
                                            ...jobData.meetingForm?.questions?.otherDebt,
                                            creditor: value,
                                        },
                                    },
                                },
                            });
                        } }),
                    React.createElement(FormInput, { label: "St\u00F8rrelse", value: jobData.meetingForm?.questions?.otherDebt?.amount, editable: editable, style: {
                            marginLeft: editable ? '20px' : '80px',
                            marginTop: '3px',
                        }, onChange: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        otherDebt: {
                                            ...jobData.meetingForm?.questions?.otherDebt,
                                            amount: value,
                                        },
                                    },
                                },
                            });
                        } }),
                    React.createElement(FormInput, { label: "Afdrages med", value: jobData.meetingForm?.questions?.otherDebt?.monthlyPayment, editable: editable, style: {
                            marginLeft: editable ? '20px' : '80px',
                            marginTop: '3px',
                        }, onChange: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        otherDebt: {
                                            ...jobData.meetingForm?.questions?.otherDebt,
                                            monthlyPayment: value,
                                        },
                                    },
                                },
                            });
                        } })),
                React.createElement("div", null),
                React.createElement("div", { style: { display: 'inline-flex' } },
                    React.createElement(FormInput, { label: "Kreditor", value: jobData.meetingForm?.questions?.otherDebt2?.creditor, editable: editable, style: { marginTop: '3px' }, onChange: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        otherDebt2: {
                                            ...jobData.meetingForm?.questions?.otherDebt2,
                                            creditor: value,
                                        },
                                    },
                                },
                            });
                        } }),
                    React.createElement(FormInput, { label: "St\u00F8rrelse", value: jobData.meetingForm?.questions?.otherDebt2?.amount, editable: editable, style: {
                            marginLeft: editable ? '20px' : '80px',
                            marginTop: '3px',
                        }, onChange: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        otherDebt2: {
                                            ...jobData.meetingForm?.questions?.otherDebt2,
                                            amount: value,
                                        },
                                    },
                                },
                            });
                        } }),
                    React.createElement(FormInput, { label: "Afdrages med", value: jobData.meetingForm?.questions?.otherDebt2?.monthlyPayment, editable: editable, style: {
                            marginLeft: editable ? '20px' : '80px',
                            marginTop: '3px',
                        }, onChange: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        otherDebt2: {
                                            ...jobData.meetingForm?.questions?.otherDebt2,
                                            monthlyPayment: value,
                                        },
                                    },
                                },
                            });
                        } })),
                React.createElement("div", null),
                React.createElement("div", { style: { display: 'inline-flex' } },
                    React.createElement(FormInput, { label: "Kreditor", value: jobData.meetingForm?.questions?.otherDebt3?.creditor, editable: editable, style: { marginTop: '3px' }, onChange: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        otherDebt3: {
                                            ...jobData.meetingForm?.questions?.otherDebt3,
                                            creditor: value,
                                        },
                                    },
                                },
                            });
                        } }),
                    React.createElement(FormInput, { label: "St\u00F8rrelse", value: jobData.meetingForm?.questions?.otherDebt3?.amount, editable: editable, style: {
                            marginLeft: editable ? '20px' : '80px',
                            marginTop: '3px',
                        }, onChange: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        otherDebt3: {
                                            ...jobData.meetingForm?.questions?.otherDebt3,
                                            amount: value,
                                        },
                                    },
                                },
                            });
                        } }),
                    React.createElement(FormInput, { label: "Afdrages med", value: jobData.meetingForm?.questions?.otherDebt3?.monthlyPayment, editable: editable, style: {
                            marginLeft: editable ? '20px' : '80px',
                            marginTop: '3px',
                        }, onChange: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        otherDebt3: {
                                            ...jobData.meetingForm?.questions?.otherDebt3,
                                            monthlyPayment: value,
                                        },
                                    },
                                },
                            });
                        } })),
                !!rkiRegistrations?.length && contact && (React.createElement("div", { style: { fontSize: '0.8em' } },
                    React.createElement("h4", null, "RKI-anm\u00E6rkninger"),
                    React.createElement(UserRkiRegistrations, { noHeader: true, user: contact }))),
                React.createElement("h4", null, "Afdragsordning"),
                React.createElement(FormCheckbox, { label: "Insolvenserkl\u00E6ring", editable: editable, checked: jobData.meetingForm?.questions?.paymentPlan?.insolvency, onToggle: async (value) => {
                        await save({
                            meetingForm: {
                                ...jobData.meetingForm,
                                questions: {
                                    ...jobData.meetingForm?.questions,
                                    paymentPlan: {
                                        ...jobData.meetingForm?.questions?.paymentPlan,
                                        insolvency: value,
                                    },
                                },
                            },
                        });
                    } }),
                React.createElement("div", { style: { display: 'inline-flex' } },
                    React.createElement(MoneyInput, { allowNull: true, placeholder: "M\u00E5nedligt afdrag", value: jobData.meetingForm?.questions?.paymentPlan?.yesAmount || null, onChange: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        paymentPlan: {
                                            ...jobData.meetingForm?.questions?.paymentPlan,
                                            yesAmount: value,
                                        },
                                    },
                                },
                            });
                        } }),
                    ' ',
                    React.createElement(DateInput, { placeholder: "Dato for f\u00F8rste afdrag", allowNull: true, value: jobData.meetingForm?.questions?.paymentPlan?.yesDate
                            ? moment(jobData.meetingForm?.questions?.paymentPlan?.yesDate)
                            : null, onChange: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        paymentPlan: {
                                            ...jobData.meetingForm?.questions?.paymentPlan,
                                            yesDate: value?.toISOString() || null,
                                        },
                                    },
                                },
                            });
                        } }),
                    !!jobData.meetingForm?.questions?.paymentPlan?.yesAmount &&
                        caseVouchers &&
                        creditor &&
                        tenant &&
                        documents &&
                        jobData.meetingForm?.questions?.paymentPlan?.yesDate && (React.createElement(PaymentPlanEstimate, { amount: jobData.meetingForm?.questions?.paymentPlan?.yesAmount, caseVouchers: caseVouchers, creditor: creditor, tenant: tenant, documents: documents, startDate: jobData.meetingForm?.questions?.paymentPlan?.yesDate }))),
                React.createElement("div", null),
                React.createElement("div", { style: { display: 'inline-flex' } },
                    React.createElement(FormCheckbox, { label: "Tilmeldes Betalingsservice - regnr.", editable: editable, checked: jobData.meetingForm?.questions?.paymentPlan?.signupBS, onToggle: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        paymentPlan: {
                                            ...jobData.meetingForm?.questions?.paymentPlan,
                                            signupBS: value,
                                        },
                                    },
                                },
                            });
                        }, value: jobData.meetingForm?.questions?.paymentPlan?.signupBSRegnr, onChange: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        paymentPlan: {
                                            ...jobData.meetingForm?.questions?.paymentPlan,
                                            signupBSRegnr: value,
                                        },
                                    },
                                },
                            });
                        } }),
                    React.createElement(FormInput, { label: "kontonr.", value: jobData.meetingForm?.questions?.paymentPlan?.signupBSKontonr, editable: editable, style: {
                            marginLeft: editable ? '20px' : '80px',
                            marginTop: '3px',
                        }, onChange: async (value) => {
                            await save({
                                meetingForm: {
                                    ...jobData.meetingForm,
                                    questions: {
                                        ...jobData.meetingForm?.questions,
                                        paymentPlan: {
                                            ...jobData.meetingForm?.questions?.paymentPlan,
                                            signupBSKontonr: value,
                                        },
                                    },
                                },
                            });
                        } }))),
            React.createElement("br", null),
            React.createElement(WYSIWYG, { label: "M\u00F8degivers bem\u00E6rkninger", html: jobData.meetingForm?.questions?.remarks, editable: editable, onSave: async (value) => {
                    await save({
                        meetingForm: {
                            ...jobData.meetingForm,
                            questions: {
                                ...jobData.meetingForm?.questions,
                                remarks: value,
                            },
                        },
                    });
                } })),
        jobData.state !== CourtMeetingState.Canceled && (React.createElement("div", { style: {
                padding: '1em',
                display: 'flex',
                justifyContent: 'center',
                gap: '1em',
            } },
            props.viewer === 'giver' && jobData.state == null ? (React.createElement(Button, { loading: meetingNotesSubmitter.isLoading, onClick: () => {
                    save({
                        state: jobData.meetingTypeId &&
                            meetingTypes.find((mt) => mt.id === jobData.meetingTypeId)
                                ?.meetingType === 'physical'
                            ? CourtMeetingState.NeedsApproval
                            : CourtMeetingState.ReadyForMeeting,
                    }, { submission: true });
                } }, "Klar til m\u00F8de")) : null,
            props.viewer === 'receiver' &&
                (jobData.state === CourtMeetingState.NeedsRevision ||
                    jobData.state === CourtMeetingState.Accepted ||
                    jobData.state === CourtMeetingState.ReadyForMeeting) ? (React.createElement(Button, { loading: meetingNotesSubmitter.isLoading, onClick: async () => {
                    if (jobData.state === CourtMeetingState.NeedsRevision ||
                        jobData.state === CourtMeetingState.Accepted ||
                        jobData.state === CourtMeetingState.ReadyForMeeting) {
                        await save({ state: CourtMeetingState.NotesSent }, { submission: true });
                    }
                } }, "Indsend")) : null,
            props.viewer === 'giver' &&
                jobData.state === CourtMeetingState.NotesSent ? (React.createElement(React.Fragment, null,
                React.createElement(Button, { loading: meetingNotesSubmitter.isLoading, onClick: () => {
                        save({ state: CourtMeetingState.Concluded }, { submission: true });
                    } }, "Godkend"),
                React.createElement(Button, { theme: "secondary", loading: meetingNotesSubmitter.isLoading, onClick: () => {
                        save({ state: CourtMeetingState.NeedsRevision }, { submission: true });
                    } }, "Foresp\u00F8rg \u00E6ndringer"))) : null))));
};
let tidPlan;
const PaymentPlanEstimate = (props) => {
    const [plan, setPlan] = useState(null);
    const calculatePlan = () => {
        const calcPlan = helpers.paymentPlans.gen(props.tenant, props.creditor, JSON.parse(JSON.stringify(helpers.vouchers.postProcessing(props.caseVouchers, {
            includeIrrecoverableVouchers: false,
            includeDeletedVouchers: false,
            includeExpiredVouchers: false,
        }))), props.documents, {
            amount: props.amount,
            startDate: props.startDate,
            interval: Interval.MONTH,
        });
        setPlan(calcPlan);
    };
    useEffect(() => {
        clearTimeout(tidPlan);
        tidPlan = setTimeout(() => {
            try {
                calculatePlan();
            }
            catch (error) {
                setPlan(null);
            }
        }, 1000);
        tidPlan;
    }, [props.amount, props.startDate]);
    if (!plan || plan.length < 2)
        return null;
    return (React.createElement("p", { style: {
            margin: '10px 0 0 10px',
        } },
        plan.length,
        " afdrag til",
        ' ',
        moment(plan[plan.length - 1].date).format(THEME.DATE_FORMAT_SHORT)));
};
//# sourceMappingURL=CourtMeeting.js.map